import { render, staticRenderFns } from "./UserGroupTags.vue?vue&type=template&id=d37ecd00&"
import script from "./UserGroupTags.vue?vue&type=script&lang=js&"
export * from "./UserGroupTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports